import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import GridsGallery from 'views/common/components/UI/GridsGallery/GridsGallery';

export const StyledBox = styled(Box)(({ theme }) => ({
  '& .MTSTitleAndShareContiner': {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(2),
    },
  },
  '& .MTSTitle': {
    textTransform: 'capitalize',
    color: theme.palette.secondary.dark,
    fontSize: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.spacing(3.5),
    },
  },
  '& .MTSDesc': {
    color: theme.palette.grey[400],
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(3),
    },
  },
  '& .MTSGalleyTitle': {
    marginBottom: theme.spacing(2),
    color: theme.palette.secondary.dark,
    textTransform: 'capitalize',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MTSGalleyIcon': {
    marginLeft: theme.spacing(1.25),
  },
}));
export const StyledGridsGallery = styled(GridsGallery)(({ theme }) => ({
  '& .HeroGallery-carousel ': {
    '& .arrow': {
      [theme.breakpoints.down('lg')]: {
        display: 'none ! important',
      },
    },
  },
  '& .react-multi-carousel-dot-list': {
    display: 'none',
  },
}));
